'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'

interface NotFoundProps {
  title?: string
  message?: string
  className?: string
  backRoute?: string
  backText?: string
}

const NotFound: React.FC<NotFoundProps> = ({
  title = "No se encontró",
  message = "El elemento que buscas no existe o no está disponible.",
  className = "",
  backRoute,
  backText = "Regresar"
}) => {
  const pathname = usePathname()

  const getParentRoute = () => {
    if (backRoute) return backRoute;
    const segments = pathname.split('/').filter(segment => segment)
    segments.pop()
    return segments.length ? `/${segments.join('/')}` : '/';
  }

  return (
    <div className={`container w-full flex flex-col justify-center items-center min-h-[50vh] ${className}`}>
      <h1 className="text-2xl font-bold text-gray-800 mb-4">{title}</h1>
      <p className="text-gray-600 text-center mb-6">{message}</p>
      <Link
        href={getParentRoute()}
        className="bg-dark01 hover:bg-dark02 text-white font-medium py-2 px-6 rounded-md transition-colors"
      >
        {backText}
      </Link>
    </div>
  )
}

export default NotFound